<template name="apply-reject">
	<div class="partner-reject-dialog">
		<!-- 拒绝申请 -->
		<el-dialog
		  title="拒绝理由"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
			<el-input
			  class="gp-textarea"
			  type="textarea"
			  v-model="content"
			  placeholder="请填写拒绝退款的理由"
			  maxlength="200"
			>
			</el-input>
			<div slot="footer">
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="confirm">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				content: '', //拒绝理由
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			close() {
				this.$emit('close');
			},
			confirm() {
				if (this.content.trim().length == 0) {
					this.$message.error("请填写拒绝理由");
					return false;
				}
				this.$emit('confirm', this.content.trim());
			}
		},
		mounted() {}
	}
</script>

<style scoped>
	.partner-reject-dialog .el-dialog {
		width: 424px;
	}
	.partner-reject-dialog .gp-textarea textarea {
		height: 100px;
	}
	.partner-reject-dialog .el-dialog__footer {
		padding-top: 20px;
	}
</style>
